export const isEnterKey = event => {
  return `${event.keyCode}` === "13";
};
